// extracted by mini-css-extract-plugin
module.exports = {"power-independence-J":"J_power-independence-J__p3TtI"};